import { Paper } from "@mui/material";
import NavbarButtons from "./NavbarButtons";

function Navbar() {
  return (
    <Paper
      sx={{
        display: { xs: "block", md: "none" },
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
      }}
      elevation={5}
    >
      <NavbarButtons />
    </Paper>
  );
}

export default Navbar;
